import * as React from "react";
import { forwardRef } from "react";
const SvgBattery = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M0 27.598v44.804h92.103V61.204H100V38.796h-7.897V27.598Zm5.257 4.477h64.33v35.85H5.257Z" />
  </svg>
);
const ForwardRef = forwardRef(SvgBattery);
export default ForwardRef;
